/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import CheckboxList from '@components/v2/CheckboxList/CheckboxList';
import Select from '@components/v2/Select';
import { translate } from '@utils/i18n';
import { FiltererOptions, IndexNamespace, SorterOptions } from '../constants';
import useFilters from '../hooks/useFilters';
import useUpdateFilters from '../hooks/useUpdateFilters';
function FilterSection({ notesEnabled, availableFilters }) {
    var _a;
    const { data } = useFilters();
    const updateFilters = useUpdateFilters();
    const filterOptions = Object.keys(FiltererOptions)
        .filter((key) => {
        const filterOption = FiltererOptions[key];
        // Show filter only if it's available for this page type and either notes are enabled or it's not the Notes filter
        return ((availableFilters ? availableFilters.includes(filterOption) : true) &&
            (notesEnabled || filterOption !== FiltererOptions.Notes));
    })
        .map((key) => ({
        title: translate(FiltererOptions[key], { namespace: IndexNamespace }),
        value: FiltererOptions[key]
    }));
    const sorterOptions = Object.values(SorterOptions).map((key) => ({
        value: key,
        label: (React.createElement("span", { className: "sorterOptionContainer" },
            React.createElement("i", { className: `fa-light fa-arrow-${key === SorterOptions.OldestToNewest ? 'up' : 'down'}-wide-short` }),
            translate(key, { namespace: IndexNamespace })))
    }));
    const onCheckFilter = (valueChecked) => {
        var _a, _b;
        updateFilters({
            filters: ((_a = data === null || data === void 0 ? void 0 : data.filters) === null || _a === void 0 ? void 0 : _a.includes(valueChecked))
                ? (_b = data === null || data === void 0 ? void 0 : data.filters) === null || _b === void 0 ? void 0 : _b.filter((val) => val !== valueChecked)
                : [...((data === null || data === void 0 ? void 0 : data.filters) || []), valueChecked]
        });
    };
    return (React.createElement("div", { className: "activity__filter" },
        React.createElement("div", { className: "sortSelectContainer" },
            React.createElement(Select, { options: sorterOptions, value: (_a = data === null || data === void 0 ? void 0 : data.sort) !== null && _a !== void 0 ? _a : SorterOptions.OldestToNewest, onChange: (value) => updateFilters({ sort: value }), label: translate('order_by', { namespace: IndexNamespace }) })),
        React.createElement("div", { className: "filtererContainer" },
            React.createElement(CheckboxList, { options: filterOptions, onChange: onCheckFilter, label: translate('show_updates', { namespace: IndexNamespace }), value: (data === null || data === void 0 ? void 0 : data.filters) || [] }))));
}
export default React.memo(FilterSection);
